<!-- 拖拽滑动 -->
<template>
  <div id="default_drag_comp"
  >
<!--  @click="goNext"
  @touchstart="down"
  @touchmove="move"
  @touchend="end" -->
    <div>
      <h4>今天是&nbsp;{{date}}</h4>
     <span>{{motto}}</span>
    </div>
    <img src="@/assets/images/steward.png">
  </div>
</template>

<script>
export default {
  name: "defaultDrag",
  data() {
    return {
      flags: false,
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: ""
    };
  },
  props:['date','motto'],
  methods: {
    // goNext() {
    //   this.$emit("goNext");
    // },
    // // 实现移动端拖拽
    // down() {
    //   let default_drag_comp = document.querySelector("#default_drag_comp");
    //   this.flags = true;
    //   var touch;
    //   if (event.touches) {
    //     touch = event.touches[0];
    //   } else {
    //     touch = event;
    //   }
    //   this.maxW = document.body.clientWidth - default_drag_comp.offsetWidth;
    //   this.maxH = document.body.clientHeight - default_drag_comp.offsetHeight;

    //   this.position.x = touch.clientX - default_drag_comp.offsetLeft;
    //   this.position.y = touch.clientY - default_drag_comp.offsetTop;
    //   this.dx = touch.clientX;
    //   this.dy = touch.clientY;
    // },
    // move(event) {
    //   event.preventDefault();
    //   let default_drag_comp = document.querySelector("#default_drag_comp");
    //   if (this.flags) {
    //     var touch;
    //     if (event.touches) {
    //       touch = event.touches[0];
    //     } else {
    //       touch = event;
    //     }
    //     this.nx = touch.clientX - this.position.x;
    //     this.ny = touch.clientY - this.position.y;

    //     if (this.nx < 0) {
    //       this.nx = 0;
    //     } else if (this.nx > this.maxW) {
    //       this.nx = this.maxW;
    //     }

    //     if (this.ny < 0) {
    //       this.ny = 0;
    //     } else if (this.ny >= this.maxH) {
    //       this.ny = this.maxH;
    //     }

    //     default_drag_comp.style.left = this.nx + "px";
    //     default_drag_comp.style.top = this.ny + "px";
    //     //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
    //     document.addEventListener(
    //       "touchmove",
    //       function() {
    //         // event.preventDefault();
    //       },
    //       false
    //     );
    //   }
    // },
    // //鼠标释放时候的函数
    // end() {
    //   this.flags = false;
    // }
  }
};
</script>
<style scoped lang="scss">
#default_drag_comp {
  width: 690px;
  max-height: 150px;
  background: #F0F4FA;
  box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 15px 35px;
  display: flex;
  position: fixed;
  bottom: 112px;
  left: 4%;
  padding-right: 125px;
  div{
    h4{
      font-size: 28px;
      color: #333;
      margin-bottom: 5px;
    }
    span{
      font-size: 24px;
      color: #999;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;

    }
  }
  img{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 90px;
    height: 140px
  }
}
</style>
